/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const InvoiceType = {
    PURCHASE: 'PURCHASE',
    DECOMMISSION: 'DECOMMISSION',
    DECOMMISSION_PRODUCT: 'DECOMMISSION_PRODUCT',
    INVENTORY: 'INVENTORY',
    CONSUMPTION: 'CONSUMPTION',
    PRODUCTION: 'PRODUCTION',
    TRANSFER: 'TRANSFER',
    RESTORATION: 'RESTORATION'
} as const;
export type InvoiceType = typeof InvoiceType[keyof typeof InvoiceType];

